<ng-container *ngIf="useDocViewer; else pdfFrame">
    <iframe class="doc-viewer"  [src]="docViewerUrl" ></iframe>
</ng-container>
<ng-template #pdfFrame>
  
    <div class="belge-viewer">
        <!-- DKM-5138 Cedric: yakınlaştırma (yalnız [yakinlastirma]="true" verilen ekranlarda; diğerleri eski görünümde) -->
        <ng-container *ngIf="yakinlastirma && isFileImage; else eskiResim">
          <div class="zoom-arac">
            <button type="button" title="Uzaklaştır" [disabled]="zoom <= zoomMin" (click)="zoomDegistir(-25)"><i class="dx-icon-minus"></i></button>
            <span class="zoom-oran">%{{ zoom }}</span>
            <button type="button" title="Yakınlaştır" [disabled]="zoom >= zoomMax" (click)="zoomDegistir(25)"><i class="dx-icon-plus"></i></button>
            <button type="button" title="Sayfaya sığdır" [disabled]="zoom === 100" (click)="zoom = 100"><i class="dx-icon-fullscreen"></i></button>
          </div>
          <div class="zoom-alan" #zoomAlan (wheel)="tekerlek($event)">
            <img [src]="url" [style.width.%]="zoom" [style.height.%]="zoom" (error)="onFileError()" />
          </div>
        </ng-container>
        <ng-template #eskiResim>
        <img
          *ngIf="isFileImage; else documentTemplate"
          [src]="url"
          (error)="onFileError()"
        />
        </ng-template>
      </div>

      <ng-template #documentTemplate>
        <!-- DKM-5164 Cedric: html/txt belge kum havuzlu iframe'de (sandbox="" → script/form/popup/aynı köken kapalı); pdf aşağıdaki eski iframe'de -->
        <iframe
          *ngIf="!isFileImage && guvenliHtml; else pdfTemplate"
          class="guvenli-html"
          sandbox=""
          referrerpolicy="no-referrer"
          [src]="url"
          (load)="onDocumentLoad()"
          (error)="onFileError()"
        ></iframe>
      </ng-template>

      <ng-template #pdfTemplate>
        <iframe
        type="application/pdf"
          *ngIf="!isFileImage ; else noTemplate"
          [src]="url"
          (load)="onDocumentLoad()"
          (error)="onFileError()"
        ></iframe>
      </ng-template>

      <ng-template #noTemplate>
        <div class="error-message">{{ failedDocMessage }}</div>
      </ng-template>





</ng-template>